export default "__VITE_ASSET__6053ccbf__"